//
import { API } from "../../api";
// Swaps an old (possibly-expired) user JWT for a fresh one.
// GET v2/refresh/user/token with the old token passed as the Bearer.
async function refresh_user_token(oldToken) {
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/refresh/user/token`, //
        authorization: oldToken,
    });
}
export { refresh_user_token };
